<div class="container py-5">
    <!-- Logo and Workshop Title -->
    <div class="text-center mb-4">
      <img src="assets/snp Image/size changed png (1).jpg" alt="FundsIndia Logo" class="mb-3" width="150" />
      <h4 class="fw-bold">Snp Money for Wealth Creation</h4>
      <button class="btn btn-success px-4 py-2">1 Hour Live Workshop</button>
    </div>
  
    <!-- Main Heading -->
    <div class="text-center mb-5 px-3">
      <h2 class="fw-bold">
        Discover How to Plan and Retire Early With SIP/Mutual Fund Investment!!!
        <span class="text-primary">Snp Money</span>
      </h2>
    </div>
  
    <!-- Workshop Details Section -->
    <!-- Webinar Details -->
  <div class="workshop-details d-flex flex-wrap justify-content-center gap-3 mb-5">
    <div class="card p-3 text-center shadow-sm">
      <h6 class="mb-1">📅 Date</h6>
      <p class="fw-bold mb-0">Every Saturday</p>
    </div>
    <div class="card p-3 text-center shadow-sm">
      <h6 class="mb-1">⏰ Time</h6>
      <p class="fw-bold mb-0">7:30 PM</p>
    </div>
    <div class="card p-3 text-center shadow-sm">
      <h6 class="mb-1">🔴 Live</h6>
      <p class="fw-bold mb-0">On ZOOM</p>
    </div>
  </div>

  <!-- Register Button -->
  <div class="text-center mb-4">
    <button class="btn btn-success btn-lg px-5 ">Register for Webinar for FREE</button>
  </div>

  
    <!-- Register Button -->
    <div class="text-center py-5">
        <p class="fw-bold text-muted fs-5 mb-0 text-decoration-line-through fw-bold">₹199</p>
        <p class="fw-bold fs-3 text-primary">FREE</p>
        <button class="btn btn-success btn-lg px-5 ">REGISTER NOW</button>
      </div>
  
    <!-- Enrollment Closing and Countdown -->
    <div class="text-center mb-4">
      <p class="text-muted mb-1">ENROLLMENT CLOSES ON DEC 20, 2024</p>
      <p class="fw-bold mb-0">
        Register In Next <span class="text-danger">{{ minutes }}</span> :
        <span class="text-danger">{{ seconds }}</span> Mins
      </p>
    </div>
  
    <!-- Speaker Details -->
    <div class="text-center mb-4">
        <img src="assets/vision/sunil.jpg" alt="Sunil Srivastava Photo" class="rounded-circle shadow-sm" width="150" height="150" />
        <h5 class="text-success mt-3 fw-bold">Sunil Srivastava</h5>
        <p class="text-muted mb-0">Founder (SNP Money), Financial Planner</p>
        <p class="text-muted mb-0">17+ Years Experience in Finance</p>
        <p class="text-muted">Location: Live Zoom Webinar Online</p>
      </div>
  </div>
 
<!-- Why Join Section -->
<section class="why-join">
    <h2 class="section-title">Why Join Early Retirement Webinar?</h2>
    <div class="grid-container">
        <div class="reason">
            <p>Retire before the standard age of 60 so that you have more time for yourself and your family.</p>
        </div>
        <div class="reason">
            <p>Have a consistent flow of income post-retirement even when you are not working.</p>
        </div>
        <div class="reason">
            <p>Live a stress-free life and be confident that your money is working for you to give you a secure future.</p>
        </div>
        <div class="reason">
            <p>Have a strategic retirement plan in place to beat inflation and make sure you will never run out of cash.</p>
        </div>
    </div>
    <div class="text-center py-5">
        <p class=" text-muted fs-5 mb-0 text-decoration-line-through fw-bold">₹199</p>
        <p class="fw-bold fs-3 text-primary">FREE</p>
        <button class="btn btn-success btn-lg px-5 ">REGISTER NOW</button>
      </div>
</section>

<!-- Discovery Section -->
<section class="discovery">
    <h2 class="section-title">What Will be Discovered in 90 Minutes Webinar</h2>
    <div class="discovery-cards">
        <div class="card">
            <h3>How Much Money Required to Invest on Monthly Basis or One Time</h3>
            <p>Learn how to determine the right investment amount for your goals.</p>
        </div>
        <div class="card">
            <h3>How to Create Portfolio of Mutual Funds</h3>
            <p>Learn how to build and manage a diversified mutual fund portfolio tailored for retirement.</p>
        </div>
        <div class="card">
            <h3>How to Invest Online and Track Through One Single Mobile App</h3>
            <p>Discover the easiest way to invest and track your investments on a mobile app.</p>
        </div>
    </div>
    <div class="text-center py-5">
        <p class="fw-bold text-muted fs-5 mb-0 text-decoration-line-through fw-bold">₹199</p>
        <p class="fw-bold fs-3 text-primary">FREE</p>
        <button class="btn btn-success btn-lg px-5 ">REGISTER NOW</button>
      </div>
</section>

<!-- Suitable Audience Section -->
<section class="audience">
    <h2 class="section-title">This Webinar is Best Suitable for...</h2>
    <div class="audience-grid">
        <div class="audience-card">Working Salaried Person</div>
        <div class="audience-card">Business Owners</div>
        <div class="audience-card">Self Employed Professional</div>
        <div class="audience-card">Freelancers & Solopreneurs</div>
    </div>
</section>
  
  <!-- About Your Coach Section -->
  <div class="py-5" style="background-color: #a4d4ff;">
    <div class="container d-md-flex align-items-center text-center text-md-start">
      <!-- Coach Image -->
      <img
        src="assets/vision/sunil.jpg"
        alt="Coach Image"
        class="rounded shadow-sm mx-auto mx-md-0"
        width="180"
        height="180"
      />
      <!-- Coach Details -->
      <div class="ms-md-4 mt-4 mt-md-0">
        <h3 class="fw-bold mb-3">About Your Coach</h3>
        <p class="mb-0">
            Mr. Sunil Srivastava is passionate about helping individuals and businesses achieve financial freedom and wealth creation through his extensive experience in the financial domain and expertise in investment planning.

            He has a total work experience of 18 years in the Financial Sector, having worked with top-level banks like HDFC BANK, KOTAK MAHINDRA BANK, and INDUSIND BANK.
        </p>
        <p class="mt-2 text-success fw-bold">Mr. Sunil Srivastava</p>
      </div>
    </div>
  </div>
  
  <!-- FAQ Section -->
  <div class="container py-5">
    <h3 class="text-center fw-bold mb-4">Frequently Asked Questions</h3>
    <div class="accordion" id="faqAccordion">
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button
            class="accordion-button"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#faq1"
          >
            How will I get the link to join the program?
          </button>
        </h2>
        <div id="faq1" class="accordion-collapse collapse show">
          <div class="accordion-body">
            You will receive an email with the Zoom link after you register for the event.
          </div>
        </div>
      </div>
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button
            class="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#faq2"
          >
            What if I don’t know anything about mutual funds?
          </button>
        </h2>
        <div id="faq2" class="accordion-collapse collapse">
          <div class="accordion-body">
            No worries! This workshop is beginner-friendly and explains everything in simple language.
          </div>
        </div>
      </div>
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button
            class="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#faq3"
          >
            Can I attend the workshop if my family members want to join too?
          </button>
        </h2>
        <div id="faq3" class="accordion-collapse collapse">
          <div class="accordion-body">
            Absolutely! The workshop is open to everyone who wants to learn.
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Price Section -->
  <div class="text-center py-5">
    <p class=" text-muted fs-5 mb-0 text-decoration-line-through fw-bold">₹199</p>
    <p class="fs-3 text-primary">FREE</p>
    <button class="btn btn-success btn-lg px-5 ">REGISTER NOW</button>
  </div>
  

  <!-- Footer Section -->
<footer class="footer">
    <p>&copy; 2024 SNP Money. All rights reserved. | <a href="mailto:support@snpmoney.com" class="footer-link">Contact Us</a></p>
</footer>